module.exports = __webpack_public_path__ + "img/title_5.94a12e0c.png";